import React from "react";

// The 4-up figure panel that sits beside the page heading on Rankings and
// Tournaments. `items` is [{ icon, value, label, sublabel }].
const StatStrip = ({ items = [], className = "" }) => (
  <div
    className={`grid grid-cols-2 divide-border overflow-hidden rounded-md border border-border bg-surface sm:grid-cols-4 sm:divide-x ${className}`}
  >
    {items.map((item) => (
      <div
        key={item.label}
        className="flex flex-col items-center gap-1 px-4 py-5 text-center"
      >
        {item.icon && <span className="text-primary">{item.icon}</span>}
        <span className="tabular text-2xl font-bold text-navy">{item.value}</span>
        <span className="text-xs font-medium text-muted">{item.label}</span>
        {item.sublabel && (
          <span className="text-[11px] text-muted/80">{item.sublabel}</span>
        )}
      </div>
    ))}
  </div>
);

export default StatStrip;
